import React, { Component } from 'react';
import Parser from 'html-react-parser';
import { withStyles } from '@material-ui/styles';
import { Grid, Hidden, Dialog } from '@material-ui/core';
import MenuIcon from '@material-ui/icons/Menu';
import CloseIcon from '@material-ui/icons/Close';
import { PickemWrapper } from '../index';
import moment from 'moment';
import sendConfirmationEmail from '../../data/mutations/confirmationEmailMutation';
import calculatePositions from '../../data/mutations/front/calculatePositions';
import useStyles from './styles';
import LandingPage from './LandingPage';
import { MIGHTYMEALS_LOGO, MIGHTYMEALS_FOOTER, MIGHTY_START_DATE } from '../../constants';

class MightyMeals extends Component {
    constructor(props){
        super(props);
        this.state = {
            current_chapter: 1,
            chapter: {},
            chapters: {},
            htpOpen: false,
            width: 0,
            height: 0,
            errorOpen: false,
            current_date: '',
            end_date: '',
        }

        this.handleClose = this.handleClose.bind(this);
        this.errorClose = this.errorClose.bind(this);
        this.resizeWindow = this.resizeWindow.bind(this);
        window.addEventListener('resize', this.resizeWindow);
    }

    componentDidMount() {
        if (this.props.game) {
            let chapters = {};
            let chapter = {};
            let closed = {};
            this.props.game.game_settings.map(ch => {
                const today = moment();
                const started = moment(ch.chapter_start_date).isSameOrBefore(today);
                const not_ended = moment(ch.chapter_end_date).isAfter(today);
                if(!chapter.chapter_id && started){
                    if(not_ended) chapter = ch;
                    else closed = ch;
                }
                chapters[ch.chapter_id] = ch;
            });
            //current chapter is called chapter
            if(!chapter.chapter_id) chapter = closed.chapter_id ? closed : chapters[1];
            this.setState({
                chapters: chapters,
                chapter: chapter,
                current_chapter: parseInt(chapter.chapter_id),
            });
        }
        this.setState({ width: window.innerWidth, height: window.innerHeight });
    }

    resizeWindow = () => {
        this.setState({ width: window.innerWidth, height: window.innerHeight });
    }

    setChapter = (index, chapter) => {
        this.setState({
          current_chapter: index,
          chapter: this.state.chapters[index],
        });
    };

    onSubmit() {
        const today = moment();
        const end_date = this.state.chapter.chapter_end_date;
        if(moment(today).isSameOrAfter(end_date)){
            this.setState({ errorOpen: true, current_date: today.format('MMMM Do'), end_date: moment(end_date).format('h:mm a') });
        } else {
            let data = {
                event_id: this.props.event._id,
                guest_id: this.props.guest._id,
                game_id: this.props.game._id,
                game_type_id: this.props.game.game_type_id,
                chapter_id: this.state.current_chapter,
            };
            
            let args = {
            event_id: parseInt(this.props.event._id),
            game_id: parseInt(this.props.game._id),
            }
            calculatePositions(args, response => {
            if(response.calculatePositions.code == 200){
                //console.log("Calculated correctly!")
            } else {
                //console.log("Positions not calculated")
            }
            })
        
            sendConfirmationEmail(data, response => {
            if (response.sendConfirmationEmail.code == 200) {
                this.props.context.history.push({
                pathname: this.props.nextUrl.next_url,
                });
            } else {
                alert(
                'You have some error while sending an email, please contact admin',
                );
            }
            });
        }
    }

    handleClose(){
        this.setState({ htpOpen: false });
    }

    errorClose(){
        this.setState({ errorOpen: false });
    }

    render(){
        const { current_chapter, chapters, chapter, htpOpen, width, height, errorOpen, current_date, end_date } = this.state;
        const { classes, game } = this.props;
        const mobile = width < 600;
        const mobile_landscape = width > height && height < 600;

        let textColor = '#303030';
        let buttonTextColor = '#000';
        if (this.props.event.page_text_color) textColor = this.props.event.page_text_color;
        const today = moment();
        const started = moment(MIGHTY_START_DATE).isSameOrBefore(today);

        return (
            <Grid container>
                <Grid item xs={12}>
                    <div className={classes.pageTitle}>
                        <img src={MIGHTYMEALS_LOGO} className={mobile_landscape ? classes.mightyLogoLandscape : classes.mightyLogo} />
                        <button className={classes.howToPlay} onClick={() => this.setState({htpOpen: true})}>
                            How To Play
                        </button>
                        <MenuIcon className={classes.howToPlayMenu} onClick={() => this.setState({htpOpen: true})} />
                    </div>
                </Grid>
                <Grid item xs={12}>
                    <h3 className={mobile && !mobile_landscape ? classes.chapterNameMobile : classes.chapterName}>
                        {chapter && started ? chapter.chapter_name : ''}
                    </h3>
                    <p className={classes.gameDesc}>
                        {started ? Parser(game.description) : ''}
                    </p>
                </Grid>
                <Grid item xs={12}>
                {started && chapter.active ?
                (
                    <PickemWrapper
                    //general props
                    event={this.props.event}
                    guest={this.props.guest}
                    game={this.props.game}
                    //Chapter details
                    setChapter={this.setChapter}
                    chapters={chapters}
                    current_chapter={current_chapter}
                    chapter={chapter}
                    //setting props
                    noTitle={true}
                    isResumbissionAllowed={true}
                    autoSelect={true}
                    excludeTieBreakerPoints={true}
                    //props for relay query
                    variables={{
                        arguments: {
                        game_id: this.props.context.params.game_id,
                        quarter_id: current_chapter,
                        },
                        next_arguments: {
                        game_id: this.props.context.params.game_id,
                        quarter_id: current_chapter + 1,
                        },
                        pickemAnswerArgument: {
                        game_id: this.props.context.params.game_id,
                        event_id: this.props.event._id,
                        quarter_id: current_chapter,
                        guest_id: this.props.guest._id,
                        },
                        args: {
                        game_id: this.props.context.params.game_id,
                        guest_id: this.props.guest._id,
                        quarter_id: current_chapter,
                        },
                    }}
                    //function props
                    onSubmit={this.onSubmit.bind(this)}
                    //style props
                    pickemContainer={classes.pickemContainer}
                    liStyle={classes.liStyle}
                    optnStyle={classes.option}
                    textStyle={{
                        fontSize: '18px',
                        marginBottom: '10px',
                    }}
                    optionStyle={{
                        backgroundColor: chapter.active
                        ? 'transparent'
                        : '#e0e0e0',
                        borderColor: buttonTextColor,
                        color: textColor,
                    }}
                    submitButtonStyle={{
                        backgroundColor: 'transparent',
                        border: `1px solid ${buttonTextColor}`,
                        color: textColor,
                    }}
                    highlightStyle={{
                        backgroundColor: buttonTextColor,
                        border: `1px solid ${buttonTextColor}`,
                        color: '#fff',
                    }}
                    pickemAlert={{
                        color: textColor,
                        backgroundColor: buttonTextColor,
                        fontSize: '30px',
                        padding: '20px',
                    }}
                    pickemRoot={{ justifyContent: 'center' }}
                    mightyMeals={true}
                    mobile={mobile}
                    mobile_landscape={mobile_landscape}
                    />
                ) :
                <div className={classes.landingContainer}>
                    <LandingPage chapter={chapters[current_chapter]} />
                </div>
                }
                </Grid>
                <Dialog
                    open={htpOpen}
                    onClose={this.handleClose}
                    maxWidth='xl'
                >
                    <div style={{width: '100%'}}>
                        <CloseIcon className={classes.dlClose} onClick={this.handleClose} />
                    </div>
                    <img className={classes.dlImage} src={MIGHTYMEALS_LOGO} />
                    <div className={classes.dlContainer}>
                        <br/>
                        <h2 className={classes.dlTitle}>HOW TO PLAY</h2>
                        <details>
                            <summary className={classes.dlSumm}>RULES OF THE GAME</summary>
                            <div className={classes.dlContent}>
                                <p>Login each day and try to predict what will happen at the Mubadala Citi Open. &nbsp;Each correct guess adds one (1) point to your score.</p>
                                <p>Get the most correct that day, win a prize.</p>
                                <p>Get the most correct over the course of the tournament, win the grand prize.</p>
                                <p>Don't forget to add the tiebreaker!</p>
                            </div>
                        </details>
                        <details>
                            <summary className={classes.dlSumm}>WHAT CAN I WIN</summary>
                            <div className={classes.dlContent}>
                                <p>As the Official Meal Prep of the Mubadala Citi Open, MightyMeals is ready to feed you like a tennis star.</p>
                                <p>Top 2 Daily Winners: Receive ONE MONTH of FREE MightyMeals (a $400 Value in the form of a gift card).</p>
                                <p>Top 2 Grand Winners: Receive TWO MONTHS of FREE MightyMeals (a $800 Value in the form of a gift card).</p>
                            </div>
                        </details>  
                        <details>
                            <summary className={classes.dlSumm}>ANYTHING ELSE I SHOULD KNOW</summary>
                            <div className={classes.dlContent}>
                                <p>For more information, please reference the contest's <a href="https://bde-disclaimer.s3.amazonaws.com/Mighty%20Meals%20Tennis%20Pick'Em%20Challenge%20Terms%20&%20Conditions.pdf" style={{textDecoration: 'none', color: '#E61E25'}}>official terms and conditions.</a></p>     
                            </div>
                        </details>
                    </div>
                </Dialog>
                <Dialog
                    open={errorOpen}
                    onClose={this.errorClose}
                    maxWidth='sm'
                    hideBackdrop={true}
                >
                    <div className={classes.errorDl}>
                        Sorry! Questions for {current_date} needed to be submitted before {end_date}.<br/>
                        Please check back after the schedule is posted for tomorrow's questions!
                    </div>
                </Dialog>
                <style jsx>
                {`
                    details[open] summary ~ * {
                        animation: open 0.5s ease-in-out;
                    }
                    @keyframes open {
                        from {
                            opacity: 0;
                            margin-top: -10px;
                        }
                        to {
                            opacity: 1;
                            margin-top: 0;
                        }
                    }
                `}
                </style>
            </Grid>
        )
    }
}

export default withStyles(useStyles)(MightyMeals);